<template>
  <div class="d-flex d-row justify-space-between align-center px-4 py-2" style="width: 100%; border-bottom: 1px solid #ddd">
    <div class="d-flex align-center" style="gap: 12px">
      <div style="position: relative; padding-top: 8px; padding-right: 8px;" class="flex-shrink-0">
        <div>
          <v-avatar v-if="job.company.logoUrl" size="54px">
            <v-img :src="job.company.logoUrl" contain/>
          </v-avatar>
          <v-avatar v-else size="54px">
            <v-img src="@/assets/no_image_white.png" contain />
          </v-avatar>
        </div>
        <div v-if="job.requestor && job.requestor.imageUrl" style="position: absolute; top: 0; right: 0;">
          <v-img :src="job.requestor.imageUrl" min-height="36px" max-height="36px" min-width="36px" max-width="36px" style="border-radius: 50%; border: 2px solid white" />
        </div>
      </div>

      <div>
        <Label :text="jobTitle" no-of-lines="1" />
        <Label v-if="requesterTitle" :text="requesterTitle" bold no-of-lines="1" />
      </div>
    </div>
    <div class="d-flex d-row align-baseline flex-shrink-0">
      <TextButton
          v-if="job.status === 1"
          class="mr-2"
          @click="onHide"
      >
        非表示にする
      </TextButton>
      <TextButton
          v-if="job.status === 2"
          class="mr-2"
          @click="onShow"
      >
        表示する
      </TextButton>
      <Button
        v-if="job.job.id"
        color="primary"
        @click="$router.push(`/jobs/${job.job.id}`)"
      >
        <Label text="求人閲覧する" />
      </Button>
    </div>
  </div>
</template>

<script>
import ComponentMixin from "@/components/ComponentMixin";
import TextButton from "@/components/atoms/TextButton";
import ApiMixin from "@/ApiMixin";
import Label from '../atoms/Label'
import Button from '../atoms/Button'

export default {
  components: { Button, Label, TextButton },
  mixins: [ComponentMixin, ApiMixin],
  type: "organism",
  name: "MessageJobOverview",
  props: {
    job: {
      type: Object
    },
    requestor: {
      type: Object
    }
  },
  computed: {
    jobTitle() {
      if (this.job.company.name && this.job.job.name) {
        return `${this.job.company.name} - ${this.job.job.name}`
      }
      return ""
    },
    requesterTitle() {
      const {post, lastName, firstName} = this.requestor || {}
      if (post && lastName && firstName) {
        return `${post}の${lastName + firstName}さんからのスカウト`
      }
      return undefined
    }
  },
  methods: {
    onShow() {
      this.updateMessageStatus(this.job.id, 1)
      this.$emit("change:status", 1)
    },
    onHide() {
      this.updateMessageStatus(this.job.id, 2)
      this.$emit("change:status", 2)
    }
  }
}
</script>

<style scoped>

</style>
